export async function optimizePdf(file: File): Promise<File> {
	try {
		const { PDFDocument } = await import("pdf-lib");
		const bytes = await file.arrayBuffer();
		const doc = await PDFDocument.load(bytes, { updateMetadata: false });
		const optimized = await doc.save({ useObjectStreams: true, addDefaultPage: false });
		if (optimized.byteLength >= file.size) return file;
		const buffer = new ArrayBuffer(optimized.byteLength);
		new Uint8Array(buffer).set(optimized);
		return new File([buffer], file.name, {
			type: "application/pdf",
			lastModified: Date.now(),
		});
	} catch {
		return file;
	}
}
